import menuClasses from "@mui/material/Menu/menuClasses";
export const MuiPaperTheme = (dt) => {
    return {
        defaultProps: {
            elevation: 1,
        },
        styleOverrides: {
            root: {
                background: dt.color.surface.key,
                boxShadow: dt.elevation.level1,
                [`.${menuClasses.root} &`]: {
                    borderRadius: dt.brand.borderRadius.small,
                    boxShadow: dt.elevation.level8,
                },
            },
            elevation0: {
                boxShadow: dt.elevation.level0,
            },
            elevation1: {
                boxShadow: dt.elevation.level1,
            },
            elevation2: {
                boxShadow: dt.elevation.level2,
            },
            elevation3: {
                boxShadow: dt.elevation.level2,
            },
            elevation4: {
                boxShadow: dt.elevation.level4,
            },
            elevation5: {
                boxShadow: dt.elevation.level4,
            },
            elevation6: {
                boxShadow: dt.elevation.level6,
            },
            elevation7: {
                boxShadow: dt.elevation.level6,
            },
            elevation8: {
                boxShadow: dt.elevation.level8,
            },
            elevation9: {
                boxShadow: dt.elevation.level8,
            },
            elevation10: {
                boxShadow: dt.elevation.level8,
            },
            elevation11: {
                boxShadow: dt.elevation.level8,
            },
            elevation12: {
                boxShadow: dt.elevation.level12,
            },
            elevation13: {
                boxShadow: dt.elevation.level12,
            },
            elevation14: {
                boxShadow: dt.elevation.level12,
            },
            elevation15: {
                boxShadow: dt.elevation.level12,
            },
            elevation16: {
                boxShadow: dt.elevation.level16,
            },
            elevation17: {
                boxShadow: dt.elevation.level16,
            },
            elevation18: {
                boxShadow: dt.elevation.level16,
            },
            elevation19: {
                boxShadow: dt.elevation.level16,
            },
            elevation20: {
                boxShadow: dt.elevation.level16,
            },
            elevation21: {
                boxShadow: dt.elevation.level16,
            },
            elevation22: {
                boxShadow: dt.elevation.level16,
            },
            elevation23: {
                boxShadow: dt.elevation.level16,
            },
            elevation24: {
                boxShadow: dt.elevation.level24,
            },
            outlined: {
                boxShadow: "none",
            },
        },
    };
};
